(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["floating-showcase"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (root.dataset.fpsReady) return;
    root.dataset.fpsReady = '1';
    var calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    var items = [].slice.call(root.querySelectorAll('[data-item]'));
    var panels = [].slice.call(root.querySelectorAll('[data-panel]'));
    var dots = [].slice.call(root.querySelectorAll('[data-dot]'));
    var ghost = root.querySelector('[data-ghost]');
    var total = items.length;
    if (!total) return;
    var active = -1;
    var thumbWrap = root.querySelector('[data-thumbs]');
    var thumbs = [];
    items.forEach(function (el, i) {
      var im = el.querySelector('[data-main]');
      if (!thumbWrap || !im) return;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'fps__thumb';
      b.setAttribute('aria-label', el.getAttribute('aria-label') || ('Piece ' + (i + 1)));
      var t = document.createElement('img');
      t.src = im.currentSrc || im.src;
      t.alt = '';
      t.loading = 'lazy';
      b.appendChild(t);
      b.addEventListener('click', function () { go(i); });
      thumbWrap.appendChild(b);
      thumbs[i] = b;
    });

    // Load a piece's other side/colours only when the shopper shows interest (hover / touch / focus)
    (function warm() {
      var conn = navigator.connection || {};
      if (conn.saveData) return;
      var done = {};
      function pull(el) {
        var m = el.querySelector('[data-main]');
        if (!m) return;
        ['data-front', 'data-back'].forEach(function (a) {
          var u = m.getAttribute(a);
          if (u && !done[u]) { done[u] = 1; var im = new Image(); im.decoding = 'async'; im.src = u; }
        });
      }
      items.forEach(function (el) {
        ['pointerenter', 'touchstart', 'focus'].forEach(function (ev) {
          el.addEventListener(ev, function () { pull(el); }, { passive: true });
        });
      });
    })();
    var nx = root.querySelector('[data-next]');
    var pv = root.querySelector('[data-prev]');
    var bk = root.querySelector('[data-overview]');

    function render() {
      root.dataset.state = active === -1 ? 'overview' : 'detail';
      items.forEach(function (el, i) { el.classList.toggle('is-active', i === active); });
      panels.forEach(function (el, i) { el.hidden = i !== active; });
      syncDots();
      if (active === -1) { alignRack(); placeRail(); }
      thumbs.forEach(function (el, i) {
        el.classList.toggle('is-active', i === active);
        if (i === active && thumbWrap) thumbWrap.scrollLeft = el.offsetLeft - (thumbWrap.clientWidth - el.offsetWidth) / 2;
      });
      if (pv) pv.disabled = active <= -1;
      if (nx) nx.disabled = active >= total - 1;
      if (ghost) {
        var n = active === -1 ? '' : ((panels[active] && panels[active].querySelector('.fps__name')) || {}).textContent || '';
        ghost.textContent = n.split(/\s+/)[0].replace(/[^\p{L}\p{N}]/gu, '');
        if (!calm && active !== -1) { ghost.classList.remove('is-pop'); void ghost.offsetWidth; ghost.classList.add('is-pop'); }
      }
    }
    var resets = [];
    var restoreT = null;
    function go(i) {
      root.style.setProperty('--dir', i >= 0 && active >= 0 && i !== active ? (i > active ? 1 : -1) : 0);
      if (i >= total) i = total - 1;
      if (i < -1) i = -1;
      var was = active;
      // leaving a piece: put its colour / view back to the default so the rack card is unchanged
      if (was >= 0 && was !== i && resets[was]) resets[was]();
      // opening a piece from the rack: remember where the rack was
      if (was === -1 && i >= 0 && scrollable()) restoreT = tc;
      active = i;
      if (i >= 0 && scrollable()) { tc = clampT(i); kick(); }
      // back to the rack: return to exactly where it was
      if (i === -1 && restoreT !== null) { if (scrollable()) { tc = restoreT; kick(); } restoreT = null; }
      render();
    }

    items.forEach(function (el, i) {
      el.addEventListener('click', function () { go(active === i ? -1 : i); });
    });
    dots.forEach(function (el, i) {
      el.addEventListener('click', function () { if (active === -1 && scrollable()) { tc = clampT(i); kick(); } else go(i); });
    });
    if (nx) nx.addEventListener('click', function () { go(active + 1); });
    if (pv) pv.addEventListener('click', function () { go(active - 1); });
    if (bk) bk.addEventListener('click', function () { go(-1); });
    var ln = [].slice.call(root.querySelectorAll('.fps__link, .fps__name-link'));
    ln.forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.stopPropagation();
        var h = a.getAttribute('href');
        if (h && h !== '#') { e.preventDefault(); window.location.assign(h); }
      });
    });
    var sx = null, sy = 0, st = 0, sScroll = 0, sOk = false;
    var swStage = root.querySelector('.fps__stage');
    if (swStage) {
      swStage.addEventListener('touchstart', function (e) {
        sOk = e.touches.length === 1 && active >= 0;
        if (!sOk) return;
        sx = e.touches[0].clientX; sy = e.touches[0].clientY; st = Date.now(); sScroll = window.pageYOffset;
      }, { passive: true });
      swStage.addEventListener('touchmove', function (e) {
        if (!sOk) return;
        // the page is scrolling vertically: this is not a swipe
        if (Math.abs(window.pageYOffset - sScroll) > 4 || Math.abs(e.touches[0].clientY - sy) > 24) sOk = false;
      }, { passive: true });
      swStage.addEventListener('touchcancel', function () { sOk = false; sx = null; }, { passive: true });
      swStage.addEventListener('touchend', function (e) {
        var ok = sOk && sx !== null && active >= 0;
        sOk = false;
        if (!ok) { sx = null; return; }
        var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
        sx = null;
        if (Math.abs(dx) > 70 && Math.abs(dx) > Math.abs(dy) * 2.5 && Date.now() - st < 700 && Math.abs(window.pageYOffset - sScroll) < 4) go(active + (dx < 0 ? 1 : -1));
      }, { passive: true });
    }
    root.addEventListener('keydown', function (e) {
      if (e.target && /^(INPUT|TEXTAREA|SELECT)$/.test(e.target.tagName)) return;
      if (e.key === 'ArrowRight') { if (active === -1 && scrollable()) { tc = clampT(Math.round(tc) + 1); kick(); } else go(active + 1); }
      if (e.key === 'ArrowLeft') { if (active === -1 && scrollable()) { tc = clampT(Math.round(tc) - 1); kick(); } else go(active - 1); }
      if (e.key === 'Escape') { go(-1); }
    });

    // Theme editor: selecting a block jumps to its first piece
    root.closest('.shopify-section') && root.closest('.shopify-section').addEventListener('shopify:block:select', function (e) {
      var id = e.detail && e.detail.blockId;
      for (var i = 0; i < items.length; i++) {
        if (items[i].getAttribute('data-block') === id) { go(i); return; }
      }
    });
    root.closest('.shopify-section') && root.closest('.shopify-section').addEventListener('shopify:block:deselect', function () { go(-1); });

    panels.forEach(function (panel, i) {
      var input = panel.querySelector('[data-variant-input]');
      var btn = panel.querySelector('.fps__cta');
      var img = items[i].querySelector('[data-main]');
      var jsonEl = panel.querySelector('[data-variants]');
      var variants = [];
      try { variants = jsonEl ? JSON.parse(jsonEl.textContent) : []; } catch (e) {}
      var groups = [].slice.call(panel.querySelectorAll('[data-option]'));
      var chosen = groups.map(function (g) {
        var a = g.querySelector('.is-active');
        return a ? a.getAttribute('data-value') : null;
      });
      function isCutout() { return !!(img && img.hasAttribute('data-front')); }
      function swapImg(src, flip) {
        if (!img || !src) return;
        var pre = new Image();
        pre.onload = function () {
          function apply() { img.removeAttribute('srcset'); img.src = src; }
          if (!img.animate || calm) { apply(); return; }
          img.getAnimations().forEach(function (a) { a.cancel(); });
          var pv = 'perspective(900px) ';
          var a1 = flip
            ? [{ transform: pv + 'rotateY(0deg)', opacity: 1 }, { transform: pv + 'rotateY(88deg)', opacity: 0.15 }]
            : [{ opacity: 1, transform: 'scale(1)' }, { opacity: 0, transform: 'scale(.95)' }];
          var a2 = flip
            ? [{ transform: pv + 'rotateY(-88deg)', opacity: 0.15 }, { transform: pv + 'rotateY(0deg)', opacity: 1 }]
            : [{ opacity: 0, transform: 'scale(.95)' }, { opacity: 1, transform: 'scale(1)' }];
          var out = img.animate(a1, { duration: flip ? 170 : 150, easing: 'ease-in', fill: 'forwards' });
          out.onfinish = function () {
            apply();
            var inn = img.animate(a2, { duration: flip ? 260 : 280, easing: 'cubic-bezier(.22,1,.36,1)' });
            inn.onfinish = function () { out.cancel(); };
          };
        };
        pre.src = src;
      }
      function currentView() {
        var vb = panel.querySelector('[data-view].is-active');
        return vb ? vb.getAttribute('data-view') : (img && img.getAttribute('data-back') ? 'back' : 'front');
      }
      function showView(flip) {
        var v = currentView();
        swapImg(img.getAttribute('data-' + v) || img.getAttribute('data-' + (v === 'front' ? 'back' : 'front')), flip);
      }
      function setPressed(list, on) {
        list.forEach(function (o) {
          o.classList.toggle('is-active', o === on);
          o.setAttribute('aria-pressed', o === on ? 'true' : 'false');
        });
      }
      function update() {
        var v = variants.filter(function (x) {
          return x.options.every(function (o, k) { return chosen[k] === null || o === chosen[k]; });
        })[0];
        if (!v) return;
        if (input) input.value = v.id;
        var lk = panel.querySelector('.fps__link');
        if (lk && lk.getAttribute('data-base')) lk.href = lk.getAttribute('data-base') + '?variant=' + v.id;
        if (btn) { btn.disabled = !v.available; btn.textContent = v.available ? 'Add to cart' : 'Sold out'; }
        var src = v.featured_image && v.featured_image.src;
        if (img && src && !isCutout() && img.getAttribute('data-cur') !== src) {
          img.setAttribute('data-cur', src);
          swapImg(src);
        }
      }
      var formEl = panel.querySelector('form');
      if (formEl && btn) {
        formEl.addEventListener('submit', function (e) {
          var cartEl = document.querySelector('cart-drawer');
          if (!cartEl || typeof cartEl.renderContents !== 'function' || !window.fetch) {
            btn.classList.add('is-loading');
            btn.textContent = 'Adding...';
            return;
          }
          e.preventDefault();
          if (btn.classList.contains('is-loading')) return;
          btn.classList.add('is-loading');
          btn.textContent = 'Adding...';
          var fd = new FormData(formEl);
          try {
            fd.append('sections', cartEl.getSectionsToRender().map(function (x) { return x.id; }));
            fd.append('sections_url', window.location.pathname);
          } catch (err) {}
          var cfg = typeof fetchConfig === 'function' ? fetchConfig('javascript') : { method: 'POST', headers: { Accept: 'application/javascript' } };
          cfg.headers = cfg.headers || {};
          cfg.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete cfg.headers['Content-Type'];
          cfg.body = fd;
          var url = (window.routes && window.routes.cart_add_url) || '/cart/add';
          var reset = function (label, ms) {
            setTimeout(function () { btn.classList.remove('is-loading'); btn.textContent = label || 'Add to cart'; }, ms || 0);
          };
          var added = false;
          fetch(url, cfg)
            .then(function (r) { return r.json(); })
            .then(function (res) {
              if (res && res.status) {
                btn.textContent = (res.description || res.message || 'Could not add');
                reset('Add to cart', 2200);
                return;
              }
              added = true;
              try {
                if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: fd.get('id') });
              } catch (err) {}
              var opened = false;
              try {
                cartEl.renderContents(res);
                cartEl.classList.add('is-visible');
                document.body.classList.add('overflow-hidden');
                opened = true;
              } catch (err) {}
              if (!opened) {
                var hb = document.querySelector('[data-cart-drawer]');
                if (hb) hb.click();
              }
              try { focusElement = btn; } catch (err) {}
              btn.textContent = 'Added to cart';
              reset('Add to cart', 1600);
            })
            .catch(function () {
              if (!added) formEl.submit();
              else reset('Add to cart', 0);
            });
        });
      }
      var vbtns = [].slice.call(panel.querySelectorAll('[data-view]'));
      vbtns.forEach(function (b) {
        b.addEventListener('click', function () {
          if (!isCutout()) return;
          setPressed(vbtns, b);
          showView(true);
        });
      });
      groups.forEach(function (g, k) {
        var opts = [].slice.call(g.querySelectorAll('[data-value]'));
        opts.forEach(function (b) {
          b.addEventListener('click', function () {
            setPressed(opts, b);
            chosen[k] = b.getAttribute('data-value');
            if (isCutout() && (b.getAttribute('data-front') || b.getAttribute('data-back'))) {
              img.setAttribute('data-front', b.getAttribute('data-front') || '');
              img.setAttribute('data-back', b.getAttribute('data-back') || '');
              showView(false);
            }
            update();
          });
        });
      });

      // snapshot of the default state, restored when the shopper goes back to the rack
      var init = {
        src: img ? img.getAttribute('src') : null,
        srcset: img ? img.getAttribute('srcset') : null,
        f: img ? img.getAttribute('data-front') : null,
        b: img ? img.getAttribute('data-back') : null,
        cur: img ? img.getAttribute('data-cur') : null,
        act: groups.map(function (g) { return g.querySelector('.is-active'); }),
        view: panel.querySelector('[data-view].is-active'),
        chosen: chosen.slice()
      };
      resets[i] = function () {
        if (!img) return;
        try { img.getAnimations().forEach(function (a) { a.cancel(); }); } catch (err) {}
        if (init.f !== null) img.setAttribute('data-front', init.f);
        if (init.b !== null) img.setAttribute('data-back', init.b);
        if (init.cur !== null) img.setAttribute('data-cur', init.cur); else img.removeAttribute('data-cur');
        if (init.src && img.getAttribute('src') !== init.src) {
          img.src = init.src;
          if (init.srcset) img.setAttribute('srcset', init.srcset);
        }
        groups.forEach(function (g, k) {
          if (init.act[k]) setPressed([].slice.call(g.querySelectorAll('[data-value]')), init.act[k]);
        });
        if (init.view) setPressed(vbtns, init.view);
        chosen = init.chosen.slice();
        var v = variants.filter(function (x) {
          return x.options.every(function (o, k) { return chosen[k] === null || o === chosen[k]; });
        })[0];
        if (v) {
          if (input) input.value = v.id;
          var lk = panel.querySelector('.fps__link');
          if (lk && lk.getAttribute('data-base')) lk.href = lk.getAttribute('data-base') + '?variant=' + v.id;
          if (btn) { btn.disabled = !v.available; btn.textContent = v.available ? 'Add to cart' : 'Sold out'; }
        }
      };
    });

    var stage = root.querySelector('.fps__stage');
    var caption = root.querySelector('[data-caption]');
    var hint = caption ? caption.textContent : '';
    var cc = (total - 1) / 2, tc = cc, prevCc = cc, sv = 0, rafId = 0;
    var down = false, dragging = false, suppress = false, sx0 = 0, c0 = 0, lx = 0, lt = 0, vel = 0, wheelT = 0;
    function spreadPx() { return parseFloat(getComputedStyle(items[0]).getPropertyValue('--fps-spread')) || 230; }
    function scrollable() { return stage && (total - 1) * spreadPx() > stage.clientWidth * 0.72; }
    function clampT(v) { return Math.max(0, Math.min(total - 1, v)); }
    var ratios = [];
    // the hook's height animates between views, so read the target value, never the animated one
    function hookPx() { return parseFloat(getComputedStyle(root).getPropertyValue('--hook')) || 0; }
    function placeRail() {
      if (!stage || root.dataset.state !== 'overview') return;
      var hh = hookPx();
      // the rail runs through the loop of the hook
      stage.style.setProperty('--rail-y', (items[0].offsetTop - items[0].offsetHeight / 2 + hh * (18 / 64) - 2.5) + 'px');
    }
    function alignRack() {
      if (!ratios || root.dataset.state !== 'overview') return;
      root.style.removeProperty('--hook');
      var hookH = hookPx();
      if (!hookH) return;
      var tops = items.map(function (el, i) {
        var im = el.querySelector('[data-main]');
        var r = ratios[i];
        if (!im || !r || !im.offsetHeight) return null;
        return r.y * Math.min(im.offsetHeight, im.offsetWidth * r.ar);
      });
      var K = 0, any = false;
      tops.forEach(function (t) { if (t !== null) { any = true; if (t > K) K = t; } });
      if (!any) return;
      if (K + 12 > hookH) { hookH = K + 12; root.style.setProperty('--hook', hookH + 'px'); }
      var maxBottom = 0;
      items.forEach(function (el, i) {
        var im = el.querySelector('[data-main]');
        var h = im ? im.offsetHeight : 0;
        var drop = tops[i] === null ? 0 : K - tops[i];
        el.style.setProperty('--drop', drop + 'px');
        if (drop + h > maxBottom) maxBottom = drop + h;
      });
      root.style.setProperty('--neck', (K + 4) + 'px');
      root.style.setProperty('--item-h', (hookH - (K + 4) + maxBottom) + 'px');
      root.classList.add('is-aligned');
    }
    // find where each hood starts (first opaque row) so every hoodie hangs from the same line
    items.forEach(function (el, i) {
      var im = el.querySelector('[data-main]');
      if (!im || im.classList.contains('is-card')) return;
      var u = im.getAttribute('src') || '';
      var small = u.indexOf('data:') === 0 ? u : (/[?&]width=\d+/.test(u) ? u.replace(/([?&]width=)\d+/, '$196') : '');
      if (!small) return;
      var t = new Image();
      if (small.indexOf('data:') !== 0) t.crossOrigin = 'anonymous';
      t.onload = function () {
        try {
          var w = 96, h = Math.max(1, Math.round(w * t.naturalHeight / t.naturalWidth));
          var cv = document.createElement('canvas'); cv.width = w; cv.height = h;
          var cx = cv.getContext('2d'); cx.drawImage(t, 0, 0, w, h);
          var d = cx.getImageData(Math.round(w * 0.3), 0, Math.round(w * 0.4), h).data, cw = Math.round(w * 0.4), row = -1;
          for (var y = 0; y < h && row < 0; y++) {
            for (var x = 0; x < cw; x++) { if (d[(y * cw + x) * 4 + 3] > 40) { row = y; break; } }
          }
          if (row >= 0) { ratios[i] = { y: row / h, ar: t.naturalHeight / t.naturalWidth }; alignRack(); placeRail(); }
        } catch (err) {}
      };
      t.src = small;
    });
    function syncDots() {
      var near = Math.max(0, Math.min(total - 1, Math.round(cc)));
      dots.forEach(function (el, i) {
        el.classList.toggle('is-active', active === -1 ? (scrollable() && i === near) : i === active);
      });
    }
    function applyC() {
      root.style.setProperty('--c', cc.toFixed(4));
      for (var i = 0; i < items.length; i++) {
        items[i].style.setProperty('--z', Math.max(1, Math.round(total - Math.abs(i - cc))));
      }
      syncDots();
    }
    function tick() {
      rafId = 0;
      var d = tc - cc;
      cc += d * 0.14;
      if (Math.abs(d) < 0.0005) cc = tc;
      var dc = cc - prevCc; prevCc = cc;
      var target = Math.max(-11, Math.min(11, -dc * spreadPx() * 0.9));
      sv += (target - sv) * 0.25;
      root.style.setProperty('--sv', sv.toFixed(2));
      applyC();
      var moving = cc !== tc || Math.abs(sv) > 0.05 || dragging;
      root.classList.toggle('is-moving', moving);
      if (moving) rafId = requestAnimationFrame(tick);
      else root.style.setProperty('--sv', 0);
    }
    function kick() { if (!rafId) rafId = requestAnimationFrame(tick); }
    if (stage) {
      stage.addEventListener('pointerdown', function (e) {
        if (active !== -1 || !scrollable() || (e.pointerType === 'mouse' && e.button !== 0)) return;
        down = true; dragging = false; sx0 = lx = e.clientX; c0 = tc; lt = performance.now(); vel = 0;
      });
      stage.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - sx0;
        if (!dragging && Math.abs(dx) > 6) {
          dragging = true;
          try { stage.setPointerCapture(e.pointerId); } catch (err) {}
          root.classList.add('is-dragging');
        }
        if (!dragging) return;
        var now = performance.now();
        if (now > lt) vel = vel * 0.6 + ((e.clientX - lx) / (now - lt)) * 0.4;
        lx = e.clientX; lt = now;
        tc = clampT(c0 - dx / spreadPx());
        kick();
      });
      var endDrag = function () {
        if (!down) return;
        down = false;
        if (dragging) {
          dragging = false;
          root.classList.remove('is-dragging');
          suppress = true;
          setTimeout(function () { suppress = false; }, 60);
          tc = clampT(Math.round(tc - (vel * 220) / spreadPx()));
          kick();
        }
      };
      stage.addEventListener('pointerup', endDrag);
      stage.addEventListener('pointercancel', endDrag);
      stage.addEventListener('click', function (e) {
        if (suppress) { e.stopPropagation(); e.preventDefault(); suppress = false; }
      }, true);
      stage.addEventListener('wheel', function (e) {
        if (active !== -1 || !scrollable()) return;
        var dx = Math.abs(e.deltaX) > Math.abs(e.deltaY) ? e.deltaX : (e.shiftKey ? e.deltaY : 0);
        if (!dx) return;
        e.preventDefault();
        tc = clampT(tc + dx / (spreadPx() * 1.2));
        kick();
        clearTimeout(wheelT);
        wheelT = setTimeout(function () { tc = clampT(Math.round(tc)); kick(); }, 140);
      }, { passive: false });
      if (window.ResizeObserver) {
        new ResizeObserver(function () {
          if (!scrollable()) { cc = tc = prevCc = (total - 1) / 2; applyC(); }
          alignRack();
          placeRail();
        }).observe(stage);
      }
    }
    if (caption) {
      items.forEach(function (el) {
        var name = el.getAttribute('aria-label') || '';
        var on = function () { caption.textContent = name; };
        var off = function () { caption.textContent = hint; };
        el.addEventListener('pointerenter', on);
        el.addEventListener('focus', on);
        el.addEventListener('pointerleave', off);
        el.addEventListener('blur', off);
      });
    }
    applyC();
    if (!calm) {
      root.classList.add('js-pre');
      var entered = false;
      var enter = function () {
        if (entered) return;
        entered = true;
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            root.classList.remove('js-pre');
            root.classList.add('is-entering');
            setTimeout(function () { root.classList.remove('is-entering'); }, 2200);
          });
        });
      };
      if ('IntersectionObserver' in window && !(window.Shopify && window.Shopify.designMode)) {
        var io = new IntersectionObserver(function (en) {
          if (en[0].isIntersecting) { io.disconnect(); enter(); }
        }, { threshold: 0.25 });
        io.observe(root);
        setTimeout(enter, 2500);
      } else { enter(); }
    }
    if (fine && !calm) {
      var raf = 0, mx = 0, my = 0;
      root.addEventListener('pointermove', function (e) {
        var r = root.getBoundingClientRect();
        mx = ((e.clientX - r.left) / r.width - 0.5) * 2;
        my = ((e.clientY - r.top) / r.height - 0.5) * 2;
        if (!raf) raf = requestAnimationFrame(function () {
          raf = 0;
          root.style.setProperty('--mx', mx.toFixed(3));
          root.style.setProperty('--my', my.toFixed(3));
        });
      });
      root.addEventListener('pointerleave', function () {
        root.style.setProperty('--mx', 0);
        root.style.setProperty('--my', 0);
      });
    }
    render();
  }
  function boot() { document.querySelectorAll('[data-fps]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();
})();
